export default function getRedirectReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_REDIRECT_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_REDIRECT_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_REDIRECT_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}